export default __webpack_public_path__ + "static/media/picTwo.ee5ed8ac.jpg";